import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ActionIcon, Button, Card, Group, Stack, Text, ThemeIcon } from '@mantine/core';
import { IconUserPlus, IconX } from '@tabler/icons-react';
import { ROUTES } from '@/routes/paths';

interface AddEmployeesCardProps {
  /** Закрыть карточку (крестик). Если не передан — крестик не показываем. */
  readonly onClose?: () => void;
}

/**
 * Онбординг-карточка Главной: приглашение добавить сотрудников. Показывается владельцу-менеджеру
 * аттестованной организации, у которой ещё нет ни одного сотрудника (см. AppHome). CTA — диплинк на
 * вкладку «Сотрудники» «Моей компании», где открывается диалог приглашения. Крестик закрывает карточку,
 * если добавлять сотрудников не планируют (решение запоминается в AppHome).
 */
export default function AddEmployeesCard({ onClose }: AddEmployeesCardProps) {
  const { t } = useTranslation();

  return (
    <Card withBorder radius="md" padding="lg" pos="relative">
      {onClose ? (
        <ActionIcon
          variant="subtle"
          color="gray"
          pos="absolute"
          top={8}
          right={8}
          onClick={onClose}
          aria-label={t('common.close')}
        >
          <IconX size={16} />
        </ActionIcon>
      ) : null}
      <Group justify="space-between" align="center" wrap="nowrap" gap="md" pr={onClose ? 28 : undefined}>
        <Group align="center" wrap="nowrap" gap="md">
          <ThemeIcon variant="light" color="lime" size={44} radius="md">
            <IconUserPlus size={24} />
          </ThemeIcon>
          <Stack gap={2}>
            <Text fw={600}>{t('app.home.addEmployees.title')}</Text>
            <Text c="gray.7" size="sm">
              {t('app.home.addEmployees.hint')}
            </Text>
          </Stack>
        </Group>
        <Button component={Link} to={ROUTES.APP_COMPANY_EMPLOYEES} leftSection={<IconUserPlus size={16} />}>
          {t('app.home.addEmployees.cta')}
        </Button>
      </Group>
    </Card>
  );
}
